<template>
  <div class="iframe-container">
    <loading-icon :value="iframeLoader" />
    <iframe @load="load" :src="iframeUrl" frameborder="0"></iframe>
  </div>
</template>
<script>
import constants from '@/utils/constants'
// import stores from '@/stores'
import { mapGetters } from 'vuex'

export default {
  name: 'MyClasses',
  data: function () {
    return {
      iframeUrl: constants.recordedClasses_url,
      userData: '',
      iframeLoader: true
    }
  },
  created: async function () {
    // document.cookie = `token=${stores.user._token}`
    // document.cookie = `classID=${stores.user.userInfo.userStudentMap.studentAdmission.classID}`
    // document.cookie = `sectionID=${stores.user.userInfo.userStudentMap.studentAdmission.sectionID}`
    // document.cookie = `franchiseeID=${stores.user.franchisee.id}`
    // document.cookie = `enrollmentID=${stores.user.userInfo.userStudentMap.studentAdmission.studentEnrollment.enrollmentCode}`
    // document.cookie = `className=${stores.user.userInfo.userStudentMap.studentAdmission.class}`
    // document.cookie = `gender=${stores.user.userInfo.concept}`
    // document.cookie = `studentName=${stores.user.userInfo.userStudentMap.studentAdmission.studentEnrollment.studentName}`
  },
  computed: {
    ...mapGetters({
      franchisee: 'getFranchisee',
      academicYear: 'getAcademicYear'
    })
  },
  watch: {
    // franchisee: async function (val) {
    //   document.cookie = `franchiseeID=${this.franchisee.id}`
    // }
  },
  methods: {
    load: function () {
      this.iframeLoader = false
    }
  }
}
</script>
<style scoped>
iframe {
  height: 100%;
  width: 100%;
  overflow-y: scroll;
}
.iframe-container {
  height: 100%;
  width: 100%;
  overflow-y: scroll;
}
</style>
